module.exports = __webpack_public_path__ + "img/am3-optin-promo.417b789.png";